import { Show, createMemo, createSignal } from "solid-js";

import Icon from "@/components/Icon";
import { sportsGameList } from "@/enum/game";
import { useGame } from "@/hooks/game/useGame";
import { useRouter } from "@/hooks/useRouter";
import { isMobile } from "@/lib/isMobile";
import { getRealPath } from "@/lib/language";
import { getGameimgurlByGameId } from "@/lib/resFolder";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { getProviderByGplat } from "@/stores/gameStore";
import { sysConfigStore } from "@/stores/sysConfigStore.ts";
import { GameIconStyle } from "@/types/compontent/base/baseEnum";

import LazyImg from "../LazyImg";
import { GameItemProps } from "./Index";

export default function GameItemTemplete(props: GameItemProps) {
  const { defaultSportGameId } = useGame();
  const [ImgError, serImgError] = createSignal(false);
  const { push, replace, getFirstPathSegment, toSport } = useRouter();
  const realImgSrc = getGameimgurlByGameId(
    props.gameId,
    props.iconFolder,
    props.extIconFolder,
    props.orgIconFolder,
    props.fileType,
  );
  const { preCheckEnterGame } = useRouter();

  const imgWidth = createMemo(() => {
    const width = 375;
    const singleImgWidth = (width - 10 * 2 - 12 * 2) / 3;
    return Math.floor(singleImgWidth);
  });

  const platName = createMemo(() => {
    const plat = getProviderByGplat(sysConfigStore, props.game?.gplat || 0);
    return plat ? plat.name : "";
  });

  const aspectRatioClass = (() => {
    switch (props.iconStyle) {
      case GameIconStyle.Rect:
        return "pb-[133%]";
      case GameIconStyle.RectHorizontal:
        return "pb-[75%]";
      case GameIconStyle.Square:
      case GameIconStyle.SquareBottom:
        return "pb-[100%]";
      // case GameIconStyle.Top10:
      //   return "pb-[133.34%]";
      default:
        return "pb-[133.33%]";
    }
  })();

  const handleClick = async () => {
    props.onclick?.();
    // 体育游戏只有betby, sport_priority_type 2025/08/14
    // 是否能进入游戏 - 预检
    if (!isMobile() || props.gameId === defaultSportGameId()) {
      const pass = await preCheckEnterGame({
        gid: `${props.gameId}`,
        itemId: `${props?.itemId}`,
      });
      if (!pass) {
        return;
      }
    }
    // 判断是否体育游戏
    if (sportsGameList.includes(props.gameId ?? defaultSportGameId())) {
      toSport(props.gameId ?? defaultSportGameId());
      return;
    }
    // 普通游戏
    if (isMobile()) {
      if (
        getFirstPathSegment(getRealPath(window.location.pathname)) ==
        "game-detail"
      ) {
        replace(handleUrl(`/game-detail/${props.gameId}`));
      } else {
        push(handleUrl(`/game-detail/${props.gameId}`));
      }
    } else {
      if (
        getFirstPathSegment(getRealPath(window.location.pathname)) == "game"
      ) {
        replace(handleUrl(`/game/${props.gameId}`));
      } else {
        push(handleUrl(`/game/${props.gameId}`));
      }
      props.enterGameCallback?.();
    }
  };

  const handleUrl = (url: string) => {
    if (props?.itemId) {
      url += `?itemId=${props?.itemId}`;
    }
    return url;
  };

  return (
    <div
      class={`group relative h-full w-full overflow-hidden transition-shadow`}
      classList={{
        "cursor-pointer": !props.noClick,
        "hover:shadow-lg": !props.nohover,
      }}
      style={{ "border-radius": `${props.radius}px` }}
      onClick={props.noClick ? undefined : handleClick}
    >
      <div
        class={`z-5 relative h-0 overflow-hidden rounded-[inherit] bg-cover bg-center bg-no-repeat ${aspectRatioClass}`}
      >
        <Show when={ImgError()} fallback={<></>}>
          <div
            class={`bg-general-bg1 absolute left-0 top-0 flex h-full w-full items-center justify-center`}
            style={{ "border-radius": `${props.radius}px` }}
          >
            <LazyImg
              src={"/images/GameDefault.png"}
              class="size-full"
              alt="game default icon"
            />
          </div>
        </Show>

        <LazyImg
          class={`absolute left-0 top-0 h-full w-full object-cover transition-all duration-300`}
          src={realImgSrc}
          alt={props.game?.name}
          onError={(value) => serImgError(value)}
          style={{ "border-radius": `${props.radius}px` }}
          width={imgWidth()}
        />

        {/* 模糊效果层 - 在hover时显示 */}
        <div
          class={`absolute left-0 top-0 z-[5] h-full w-full bg-black/10 opacity-0 backdrop-blur-sm duration-300 ${!props.nohover ? "group-hover:opacity-100" : ""}`}
          style={{ "border-radius": `${props.radius}px` }}
        />

        {/* 平台名贴底部中间 */}
        {platName() && (
          <div class="text-general-light absolute bottom-1 left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded px-2 py-0.5 text-[10px]">
            {platName()}
          </div>
        )}
        <div
          class={`absolute bottom-0 left-0 right-0 top-0 z-10 h-full w-full bg-black/50 opacity-0 duration-300 ${!props.nohover ? "group-hover:opacity-100" : ""}`}
          style={{ "border-radius": `${props.radius}px` }}
        >
          <div class="flex h-full w-full flex-col items-center justify-center gap-2">
            <div class="text-general-light w-4/5 break-normal text-center text-[14px] font-[800] leading-tight">
              {props.game?.name}
            </div>
            <div class="bg-general-light/20 flex h-[42px] w-[42px] items-center justify-center rounded-full pl-[2px]">
              <Icon
                name="general/play"
                class="text-general-light size-[18px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
